import { cx } from "@emotion/css";
import { FC, ReactNode } from "react";
import Button from "react-bootstrap/Button";
import styles from "./style.module.scss";

interface StateProps {
  children: ReactNode;
  onClick?: (data: any) => void;
  type?: "primary" | "secondary";
  width?: string;
  disabled?: boolean;
  className?: string;
}

const SubmitButton: FC<StateProps> = ({
  children,
  width,
  onClick,
  type = "primary",
  disabled,
  className,
}) => {
  const classn = type === "primary" ? styles.btnPrimary : styles.btnOutline;
  const finalCss = className ? cx(classn, className) : classn;
  return (
    <>
      <Button
        size="sm"
        style={{ width }}
        variant="primary"
        onClick={onClick}
        className={finalCss}
        disabled={disabled}
        type="submit"
      >
        {children}
      </Button>
    </>
  );
};

export default SubmitButton;
